import { createSlice } from '@reduxjs/toolkit';
import { SocialPagesState } from '../../shared/types/socialTypes';
import { fetchSocialPages, createSocialPage } from '../../shared/api/socialApi';

export const initialState: SocialPagesState = {};

const socialSlice = createSlice({
    name: 'social',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialPages.pending, (state, action) => {
                const provider = action.meta.arg;
                if (!state[provider]) {
                    state[provider] = {
                        pages: [],
                        meta: null,
                        loading: false,
                        error: null,
                    };
                }
                state[provider].loading = true;
                state[provider].error = null;
            })
            .addCase(fetchSocialPages.fulfilled, (state, action) => {
                const { provider, pages, meta } = action.payload;
                state[provider] = {
                    pages,
                    meta,
                    loading: false,
                    error: null,
                };
            })
            .addCase(fetchSocialPages.rejected, (state, action) => {
                const provider = action.meta.arg;
                if (!state[provider]) {
                    state[provider] = {
                        pages: [],
                        meta: null,
                        loading: false,
                        error: null,
                    };
                }
                state[provider].loading = false;
                state[provider].error =
                    (action.payload as any)?.general || `Failed to fetch ${provider} pages`;
            })
            .addCase(createSocialPage.pending, (state, action) => {
                const provider = action.meta.arg.provider;
                if (!state[provider]) {
                    state[provider] = {
                        pages: [],
                        meta: null,
                        loading: false,
                        error: null,
                    };
                }
                state[provider].loading = true;
                state[provider].error = null;
            })
            .addCase(createSocialPage.fulfilled, (state, action) => {
                const provider = action.meta.arg.provider;
                if (!state[provider]) {
                    state[provider] = {
                        pages: [],
                        meta: null,
                        loading: false,
                        error: null,
                    };
                }
                state[provider].pages.push(action.payload);
                state[provider].loading = false;
            })
            .addCase(createSocialPage.rejected, (state, action) => {
                const provider = action.meta.arg.provider;
                if (!state[provider]) {
                    state[provider] = {
                        pages: [],
                        meta: null,
                        loading: false,
                        error: null,
                    };
                }
                state[provider].loading = false;
                state[provider].error =
                    (action.payload as any)?.general || `Failed to create page for ${provider}`;
            });
    },
});

export default socialSlice.reducer;
